<div>
    <h1>Health Check</h1>
    <p>Status: {{ status }}</p>
</div>